module.exports = __webpack_public_path__ + "img/expired.33466af7.svg";